export default {
  newspaperPdfs: [],
  newspaperPdfInfos: {
    id: null,
    url: null,
    activated: true,
    schedule_publish_at: null,
  },
  totalPages: 1
}
